<template>
  <div class="terms-container">
    <div class="inline mx-auto">
      <div class="checkbox-group">
        <v-checkbox v-model="promotionsValue" :error="terms.promotions.error" color="secondary"
          :label="$t('shared.i_want_promotions')" class="avm-checkbox mr-0">
          <template #label>
            <span class="ml-2" v-on:click.stop> {{$t('shared.i_want_promotions')}} </span>
          </template>

        </v-checkbox>
      </div>
      <div class="checkbox-group">
        <v-checkbox v-model="termsValue" :error="terms.terms.error" color="secondary" class="avm-checkbox m-0">
          <template #label>
            <span v-if="inGiftFunnel" class="ml-2" v-on:click.stop>{{$t('shared.i_accept')}} <a class='underline' href='/terminos-y-condiciones-cupones' target='_blank'>{{$t('shared.terms_and_conditions')}}</a> {{$t('shared.and')}} <button class='underline' @click="openPrivacyLawing">{{$t('shared.privacy_policy')}}</button> </span>
            <span v-else>{{$t('shared.i_accept')}} <button @click="openTermsLawing" class='underline'>{{$t('shared.terms_and_conditions')}}</button> {{$t('shared.and')}} <button class='underline' @click="openPrivacyLawing">{{$t('shared.privacy_policy')}}</button></span>
          </template>
        </v-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_TERMS } from "../../../../../../../store/booking/getter-types";
import { SET_TERMS } from "../../../../../../../store/booking/mutation-types";

export default {
  computed: {
    promotionsValue: {
      get() {
        return this.$store.getters[GET_TERMS].promotions.value;
      },
      set(val) {
        this.$store.commit(SET_TERMS, {
          ...this.$store.getters[GET_TERMS],
          promotions: {
            error: false,
            value: val,
          },
        });
      },
    },
    termsValue: {
      get() {
        return this.$store.getters[GET_TERMS].terms.value;
      },
      set(val) {
        this.$store.commit(SET_TERMS, {
          ...this.$store.getters[GET_TERMS],
          terms: {
            error: false,
            value: val,
          },
        });
      },
    },
    terms() {
      return this.$store.getters[GET_TERMS];
    },
    inGiftFunnel() {
      return window.location.href.includes("regala");
    },
    acceptTermsTranslation() {
      const urlContainsRegala = window.location.href.includes("regala");
      return urlContainsRegala ? this.$t('shared.i_accept_the_terms-coupons') : this.$t('shared.i_accept_the_terms');
    },
  },

  watch: {
    promotionsValue(promotions) {
      this.$emit("update:promotions", promotions);
    },
  },
  methods: {
    openTermsLawing() {
      const termsLawingButton = document.getElementsByClassName("lawwwing-document-open terms")[0];
      if(termsLawingButton) termsLawingButton.click();
    },
    openPrivacyLawing() {
      const privacyLawingButton = document.getElementsByClassName("lawwwing-document-open priv")[0];
      if(privacyLawingButton) privacyLawingButton.click();
    },
  },
};
</script>
<style lang="scss" src="./Terms.scss"></style>
